import { Paper, Typography } from '@mui/material'

const NoResultsContainer = () => {
  
  return (
    <div className='flex items-center justify-center h-full '>
      <Paper className='px-4 py-2'>
        <Typography className='text-center text-muted-foreground opacity-90'>No results have been found for this search</Typography> 
        <Typography className='text-center text-muted-foreground opacity-75'>
          Please change your options or select a different student
        </Typography>
      </Paper>
    </div>
  )
}
export default NoResultsContainer